import {
  skipToken,
  useMutation,
  useQuery,
  useQueryClient
} from '@tanstack/react-query'
import { type CreateLab } from '../types/types'
import { useAuth } from './useAuth'
import { throwOnError } from '../utils/throwOnError'

export const useGetLabByIdQuery = (labId?: number) => {
  const { authFetch } = useAuth()
  return useQuery({
    queryKey: ['lab', labId],
    queryFn: labId
      ? async () => {
          const { data, error } = await authFetch().GET('/labs/{labId}', {
            params: {
              path: { labId }
            }
          })
          if (error) {
            throwOnError(error)
          }
          return data
        }
      : skipToken
  })
}

export const useGetLabsQuery = (isEnabled = true) => {
  const { authFetch } = useAuth()
  return useQuery({
    queryKey: ['labs'],
    enabled: isEnabled,
    queryFn: async () => {
      const { data, error } = await authFetch().GET('/labs')
      if (error) {
        throwOnError(error)
      }
      return data
    }
  })
}

export const useCreateLabMutation = () => {
  const queryClient = useQueryClient()
  const { authFetch } = useAuth()
  return useMutation({
    mutationFn: async (lab: CreateLab) => {
      const { data, error } = await authFetch().POST('/labs', {
        body: lab
      })
      if (error) {
        throwOnError(error)
      }
      return data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['labs']
      })
    }
  })
}

export const useDeleteLabMutation = () => {
  const queryClient = useQueryClient()
  const { authFetch } = useAuth()
  return useMutation({
    mutationFn: async (labId: number) =>
      await authFetch().DELETE('/labs/{labId}', {
        params: {
          path: { labId }
        }
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['labs']
      })
    }
  })
}
